// The reorderable "view" sections of the actions sidebar that the user can hide
// via the settings modal's "Désactiver éléments" category. Tool panels (Plan
// Mode, Construction, …) are not hideable — they appear only while their mode is
// active. Keep the ids in sync with Sidebar's DEFAULT_SECTION_ORDER.
export const HIDEABLE_SECTIONS = [
  { id: 'vue', label: 'Vue' },
  { id: 'signets', label: 'Signets, partage & export' },
  { id: 'visualisation', label: 'Visualisation' },
  { id: 'bulles', label: 'Carte à bulles' },
  { id: 'elements-rp', label: 'Éléments RP' },
  { id: 'monde', label: 'Monde réel' },
  { id: 'organisations', label: 'Organisations' },
  { id: 'projection', label: 'Projection' },
  { id: 'filtres', label: 'Filtres' },
  { id: 'stats', label: 'Statistiques' },
]
